import { getMarketRates } from './PricingWebAPIUtils';

export const useGetMarketShipperRates = async (marketId, limit, offset) => {
  const ratesRes = await getMarketRates(marketId, limit, offset);
  const rates = ratesRes?.data || [];
  return {
    rates,
    total: ratesRes?.data?.count || 0,
  };
};
